import type { PinnableFeedType } from '~/hooks/useDefaultFeed';

/**
 * Common navigation routes used throughout the application
 */
export const ROUTES = {
  FEEDS_GLOBAL: '/feeds/global',
  FEEDS_LOCAL: '/feeds/local',
  FEEDS_NETWORK: '/feeds/network',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RouteValue = (typeof ROUTES)[RouteKey];

export const FEED_ROUTES: Record<PinnableFeedType, RouteValue> = {
  global: ROUTES.FEEDS_GLOBAL,
  local: ROUTES.FEEDS_LOCAL,
  network: ROUTES.FEEDS_NETWORK,
};

/** Drill-down page listing the posts that use a hashtag (`hashtag` includes the leading '#') */
export function getHashtagHref(hashtag: string) {
  return { pathname: '/hashtag/[tag]', params: { tag: hashtag.slice(1) } } as const;
}

export function getMemberPath(member: { UserName: string; IsEvent?: boolean }) {
  return (member.IsEvent ? `/events/${member.UserName}` : `/@/${member.UserName}`) as `/@/${string}`;
}
